import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getBreadcrumbConfig } from '../static/constants/breadcrumbConfig';

export const useBreadcrumb = () => {
  const location = useLocation();

  const breadcrumbConfig = useMemo(() => {
    return getBreadcrumbConfig(location.pathname);
  }, [location.pathname]);

  const visibleBreadcrumbs = useMemo(() => {
    return breadcrumbConfig.filter((item) => item.isVisible);
  }, [breadcrumbConfig]);

  return {
    breadcrumbConfig,
    visibleBreadcrumbs,
  };
};
